/* 
 * Custom Jquery for this theme
 */

jQuery(function ($) {

  __window = $(window);
  __body = $('body');
  __header = $('header');
  __footer = $('footer');


  __winwidth = __window.width();
  __winheight = __window.height();

  /* For iOS touch hover effect */
  document.addEventListener("touchstart", function () { }, false);

  if (jQuery('#custom-select').length > 0) {
    jQuery("#custom-select").selectmenu();
  }

  if (jQuery('#custom-select1').length > 0) {
    jQuery("#custom-select1").selectmenu();
  }

  if (jQuery('#bottom-search').length > 0) {
    jQuery("#bottom-search").selectmenu({
      change: function (event, ui) {
        window.location.href = this.value;
      }
    });
  }

  if (jQuery('.orderby').length > 0) {
    jQuery(".orderby").selectmenu({
      change: function (event, data) {
        jQuery("form.woocommerce-ordering").submit();
      }
    });
  }

  if (jQuery('#select-one').length > 0) {
    jQuery("#select-one").selectmenu();
  }

  if (jQuery('#select-two').length > 0) {
    jQuery("#select-two").selectmenu();
  }


  if (jQuery('#select-three').length > 0) {
    jQuery("#select-three").selectmenu();
  }

  if (jQuery('#select-four').length > 0) {
    jQuery("#select-four").selectmenu();
  }

  if (jQuery('#select-five').length > 0) {
    jQuery("#select-five").selectmenu();
  }

  if (jQuery('#select-six').length > 0) {
    jQuery("#select-six").selectmenu();
  }

  if (jQuery('#select-seven').length > 0) {
    jQuery("#select-seven").selectmenu();
  }

  if (jQuery('#braspag_creditcard-card-installments').length > 0) {
    jQuery("#braspag_creditcard-card-installments").selectmenu();
  }

  if (jQuery('#accordion').length > 0) {
    jQuery("#accordion").accordion({ heightStyle: "content" });
  }

  if (jQuery('#accordion-faq').length > 0) {
    jQuery("#accordion-faq").accordion({ heightStyle: "content" });
  }

  if (jQuery('#accordion-faq1').length > 0) {
    jQuery("#accordion-faq1").accordion({ heightStyle: "content", collapsible: true, active: false });
  }
  if (jQuery('.schema-faq-section').length > 0) {
    jQuery('.schema-faq-section').accordion({ heightStyle: "content", collapsible: true, active: false });
  }

  var bannerSection = document.querySelectorAll('.banner-section .swiper-container');

  if (bannerSection) {
    bannerSection.forEach(banner => {
      var bannerSectionCount = banner.querySelectorAll('.swiper-slide');
      if (bannerSectionCount.length > 1) {
        var swiper = new Swiper(bannerSection, {
          //effect: 'fade',
          loop: true,
          speed: 1500,
          autoplay: {
            delay: 5000,
          },
          navigation: {
            nextEl: '.banner-section .swiper-button-next',
            prevEl: '.banner-section .swiper-button-prev',
          },
        });
      }
    });
  }

  if (jQuery('.banner-section.contact-banner .swiper-container').length > 0) {
    if (__winwidth > 767) {
      var swiper = new Swiper('.banner-section.contact-banner .swiper-container', {
        /*effect: 'fade',*/
        loop: true,
        speed: 1500,
        autoplay: {
          delay: 5000,
        },
        navigation: {
          nextEl: '.banner-section.contact-banner .swiper-button-next',
          prevEl: '.banner-section.contact-banner .swiper-button-prev',
        },
      });
    }
  }

  /*  jQuery('body').on('click', '.search-icon', function () {
     jQuery(this).next().slideToggle();
   }); */

  jQuery('body').on('click', '.menu-icon', function () {
    jQuery('header').toggleClass("menu-open");
  });
  jQuery(document).mouseup(function (e) {
    var container = jQuery('.mobile-menu ul, .menu-icon');
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      jQuery('header').removeClass("menu-open");
    }
  });

  if (__winwidth < 768) {
    jQuery('.account-section .left-sidebar').click(function (s) {
      s.preventDefault();
      //jQuery(this).siblings().closest('.right-account-details').find('.left-sidebar').next().addClass('fjfjf');
      jQuery(this).siblings().closest('.right-account-details').find('.left-sidebar').removeClass('active');
      jQuery(this).addClass('active');
      jQuery(this).siblings().closest('.right-account-details').find('.for-hide-mobile').slideUp();
      jQuery(this).next().slideDown();
    });
  }

});

jQuery(window).on('load resize', function () {

  __window = jQuery(window);
  __winwidth = __window.width();

  __container__width = jQuery('.container').outerWidth();

  __image__width = jQuery('.offer-section .inner-offer-col').outerWidth();
  __left__position = (__winwidth - __image__width) / 2;
  __left__position = __left__position - 20;


  if (__winwidth < 768) {
    jQuery('.offer-section .inner-offer-col').css('margin-right', -__left__position);
    jQuery('.offer-section .inner-offer-col').css('margin-left', -__left__position);
  }

  if (jQuery('.destaques-section .swiper-container').length > 0) {
    var swiper = new Swiper('.destaques-section .swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 22,
      loop: 'true',
      speed: 1000,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: '.destaques-section .swiper-button-next',
        prevEl: '.destaques-section .swiper-button-prev',
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 4,
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 5
        },
        767: {
          spaceBetween: 22,
        }
      }
    });
  }

  if (jQuery('.destaques-section.not-active-slider .swiper-container').length > 0) {
    var swiper = new Swiper('.destaques-section.not-active-slider .swiper-container', {
      slidesPerView: 4,
      spaceBetween: 5,
      loop: 'true',
      speed: 1000,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: '.destaques-section.not-active-slider .swiper-button-next',
        prevEl: '.destaques-section.not-active-slider .swiper-button-prev',
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 5
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 5
        },
        // when window width is >= 640px
        767: {
          slidesPerView: 4,
          spaceBetween: 5
        }
      }
    });
  }

  if (jQuery('.inner-impecavel-slider .swiper-container').length > 0) {
    var swiper = new Swiper('.inner-impecavel-slider .swiper-container', {
      effect: 'coverflow',
      grabCursor: 'true',
      centeredSlides: 'true',
      slidesPerView: 'auto',
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 5000,
      },
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 118,
        modifier: 3,
        slideShadows: false,
      },
      navigation: {
        nextEl: '.inner-impecavel-slider .swiper-button-next',
        prevEl: '.inner-impecavel-slider .swiper-button-prev',
      },
    });
  }

  if (jQuery('.inner-impecavel-slider-gallery .gallery-thumbs').length > 0) {

    var galleryThumbs = new Swiper('.inner-impecavel-slider-gallery .gallery-thumbs', {
      slidesPerView: 3,
      freeMode: true,
      loop: 'true',
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });
  }
  if (jQuery('.inner-impecavel-slider-gallery .gallery-top').length > 0) {

    var gallery = jQuery('.inner-impecavel-slider-gallery .gallery-top');
    var galleryTop = new Swiper(gallery, {
      spaceBetween: 0,
      loop: 'true',
      navigation: {
        nextEl: gallery.parent().find('.swiper-button-next'),
        prevEl: gallery.parent().find('.swiper-button-prev'),
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });
  }
});

if (jQuery('.product-descrip-section .gallery-thumbs, .grand-taste-top-section .gallery-thumbs').length > 0) {
  jQuery('.product-descrip-section .gallery-thumbs, .grand-taste-top-section .gallery-thumbs').each(function (index) {
    var thumbs = jQuery('.product-descrip-section .gallery-thumbs:eq(' + index + '), .grand-taste-top-section .gallery-thumbs:eq(' + index + ')');
    var galleryThumbs = new Swiper(thumbs, {
      spaceBetween: 7,
      slidesPerView: 3,
      freeMode: true,
      loopedSlides: 10,
      loop: 'true',
      speed: 1000,
      autoplay: {
        delay: 5000,
      },
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });
    if (jQuery('.product-descrip-section .gallery-top, .grand-taste-top-section .gallery-top').length > 0) {
      var gallery = jQuery('.product-descrip-section .gallery-top:eq(' + index + '), .grand-taste-top-section .gallery-top:eq(' + index + ')');
      var galleryTop = new Swiper(gallery, {
        spaceBetween: 2,
        loop: 'true',
        loopedSlides: 10,
        speed: 1000,
        autoplay: {
          delay: 5000,
        },
        navigation: {
          nextEl: gallery.parent().find('.swiper-button-next'),
          prevEl: gallery.parent().find('.swiper-button-prev'),
        },
        thumbs: {
          swiper: galleryThumbs
        }
      });
    }
  })

}
else {
  if (jQuery('.product-descrip-section .gallery-top, .grand-taste-top-section .gallery-top').length > 0) {

    var $gallery = jQuery('.product-descrip-section .gallery-top, .grand-taste-top-section .gallery-top');

    var galleryTop = new Swiper($gallery, {
      spaceBetween: 2,
      loop: 'true',
      speed: 1000,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: $gallery.parent().find('.swiper-button-next'),
        prevEl: $gallery.parent().find('.swiper-button-prev'),
      }
    });
  }
}
//cart page
//quantity
jQuery(document).on('click', '.plus', function (e) {
  e.preventDefault();
  var val = jQuery(this).parent().find('input[type=number]');
  val.focus();
  val.val(parseInt(val.val()) + 1);
  jQuery("body").trigger('qty_changed', [val]);
});
jQuery(document).on('click', '.minus', function (e) {
  e.preventDefault();
  var val = jQuery(this).parent().find('input[type=number]');
  val.val(parseInt(val.val()) - 1);
  val.focus();
  if (val.val() == 0) {
    val.val(1);
  }
  else {
    jQuery(document.body).trigger('qty_changed', [val]);
  }
});

jQuery("body").on('qty_changed', function () {
  var update = jQuery(':input[name="update_cart"]');
  if (update.length > 0) {
    update.removeAttr("disabled").attr("clicked", "true").trigger('click');
  }
});


document.addEventListener("DOMContentLoaded", function (e) {
  var wpcf7Casamento = document.querySelector(".casamentos-form-section .wpcf7");

  if (wpcf7Casamento) {
    var convidados;
    var buffet;
    var espaco;
    var previewCerimonia = wpcf7Casamento.querySelector(".preview-cerimonia");
    var previewMenu = wpcf7Casamento.querySelector('.preview-menu');
    var priceCerimonia = eval(previewCerimonia.getAttribute('data-value'));
    var auxPriceCerimonia = priceCerimonia;

    wpcf7Casamento.addEventListener("change", function (e) {
      var elem = e.target;
      switch (elem.name) {
        case 'convidados':
          convidados = parseInt(elem.value);
          //espaco = '';
          espacoOptions(convidados);
          break;
        case 'menu-casamento':
          /*      buffetText = elem.options[elem.selectedIndex].innerHTML;
               buffet = buffetText.replace(/\D/g, "") * 0.01; */
          buffet = menu_casamento[elem.selectedIndex];
          previewMenu.innerHTML = form_menus_casamento[elem.selectedIndex];
          break;
        case 'cerimonia_no_local':
          previewCerimonia.style.display = elem.value == "Não" ? 'none' : 'block';
          priceCerimonia = elem.value == "Não" ? 0 : auxPriceCerimonia;
          break;
        case 'espaco':
          //value = elem.value;
          value = form_espacos[elem.selectedIndex];
          espaco = value.split("|");
          espaco = eval(espaco[0]) + eval(espaco[0] * (espaco[1] * 0.01));
          espaco = espaco ? espaco : 0;
          break;
        default:
          break;
      }
      previewCasamento(convidados, buffet, espaco, priceCerimonia);
    });

    function espacoOptions(convidados) {
      var espacoSelect = wpcf7Casamento.querySelector('#espaco');
      var espacOoptions = espacoSelect.options;
      espacoSelect.selectedIndex = 0;
      espaco = '';
      /* 
            if (espacOoptions[espacoSelect.selectedIndex].getAttribute('disabled')) {
              espacoSelect.selectedIndex = 0;
            } */

      for (let index = 0; index < espacOoptions.length; index++) {
        espacOoptions[index].removeAttribute('disabled');
        //var dataConvidados = espacOoptions[index].getAttribute('data-convidados');
        var dataConvidados = form_convidados_range[index]
        if (dataConvidados) {
          dataConvidados = dataConvidados.split('|');
          //if (convidados > parseInt(dataConvidados[1])) {
          if (!between(convidados, dataConvidados[0], dataConvidados[1])) {
            espacOoptions[index].setAttribute('disabled', true);
          }
        }
      }
    }

    function previewCasamento(convidados, buffet, espaco, cerimonia) {
      var previewCasamento = wpcf7Casamento.querySelector('#preview-casamento');
      if (convidados && buffet && espaco) {
        var price = (convidados * buffet) + espaco + cerimonia;
        previewCasamento.innerHTML = price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      } else {
        previewCasamento.innerHTML = "";
      }
    }

    function checkNumber(number) {
      return number !== '' && !isNaN(number) ? true : false;
    }

    function between(x, min, max) {
      return x >= min && x <= max;
    }
  }


  /*   if ( document.querySelector('.page-casamentos') ) {
      document.querySelector('.btn-form-casamento').addEventListener("click", function(e){
        //e.preventDefault();
        document.querySelector('.casamentos-form-section').style.display = "block";
      });
    } */

});

jQuery(document).ready(function ($) {

  jQuery(document).on('click', 'a[href^=\\#]', function (event) {
    event.preventDefault();
    $href = jQuery(this).attr('href');

    // Seleciona o elemento correspondente ao href
    var targetElement = document.querySelector($href);
  
    if (targetElement) {
      if ($href = "#simulacao") {
        jQuery($href + ' .casamentos-form-section').show();
      }

      jQuery('html, body').animate({
        scrollTop: targetElement.offsetTop
      }, 500);
    }
  });

  //Masks
  if (typeof IMask === 'function') {
    var tels = document.querySelectorAll('.wpcf7-form-control[type=tel]', '.wpcf7-tel', '.tel-mask');

    if (tels) {
      tels.forEach(el => {
        var phoneMask = IMask(el, { mask: '(00) 00000-0000' });
      });
    }

    var dates = document.querySelectorAll('.wpcf7-form-control[type=date]', '.wpcf7-date', '.date-mask');

    if (dates) {
      dates.forEach(el => {
        console.log(el);
        el.setAttribute('type', 'text');
        var dateMask = IMask(
          el,
          {
            mask: '00/00/0000'
          });

        if (typeof $({}).datepicker == 'function') {
          $(el).datepicker({
            dateFormat: 'dd/mm/yy',
            altFormat: "yy-mm-dd",
            //minDate: 0,
          });
        }
      });
    }
  }


});



